<template>
    <div class="alert alert-info fade show" role="alert">
        <i class="fi fi-close-a"></i>
        <span class="ml-2">No se encontaron resultados</span>
    </div>
</template>
<script>
export default {

}
</script>
<style>

</style>
